module.exports = __webpack_public_path__ + "static/media/material_60y_y-1.a125b0c9.csv";